import SuperSearchList from "../shared/SuperSearch/SuperSearchList";
import handleSetDropdownData from "../../utils/HandleSetDropdownData";
import { useSelector } from "react-redux";
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import isNull from "../../utils/NullChecking";
import { ServerRequestProtected } from "../../utils/ServerDataRequest";
import { enumUtil } from "../../utils/Enum";
import DropdownValueHandler from "../shared/SuperSearch/DropdownValueHandler";
import Loader from "../shared/Loader/Loader";
import FormValidator from "../../utils/FormValidator";
import SuperSearchSingleClient from "../shared/SuperSearch/SingleSelection/SuperSearchSingleClient";

const AddNewGroupEncounter = forwardRef((props, ref) => {
    let { isAiEncounter, AddNewEncounter } = props;
    let valModal = {}
    let ValidationModal = {
        GroupIdentifierVal: "",
        SeenByVal: "",
        FacilityVal: "",
        EncounterTypeVal: "",
        NoteTypeVal: "",
    }
    let Encounter_Modal = {
        EncounterID: '',
        EncounterType: '',
        NoteType: '',
        EHRTemplateID: '',
        SeenBy: '',
        Facility: '',
        IsGroupAppointment: 'true',
        GroupIdentifier: '',
        IsAIGenerated: 'false',
        EncounterDate: '',
    }
    let providerDD = useSelector(state => state.GeneralDropDownsReducer.Provider);
    let locationDD = useSelector(state => state.GeneralDropDownsReducer.Location);
    const visitTypes = useSelector(state => state.GeneralDropDownsReducer.EncounterType);
    let noteTypes = useSelector(state => state.NoteTypeDDReducer);
    const API_URL_GENERAL = enumUtil.controller.General;

    const [mainGrpEncounterModal, setMainGrpEncounterModal] = useState(Encounter_Modal);
    const [saveGrpEncounterModal, setSaveGrpEncounterModal] = useState({});
    const [GrpEncounterValidation, setGrpEncounterValidation] = useState(ValidationModal)
    const [is, setIs] = useState(true);
    const [showParticipant, setShowParticipant] = useState(false);
    const [appointmentDD, setAppointmentDD] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedPatients, setSelectedPatients] = useState([])

    const handleChangeDD = (e) => {
        setIs(false);
        let { name, value } = e.target;
        setMainGrpEncounterModal({ ...mainGrpEncounterModal, [name]: value });
    }
    const handleSelectedData = (selectedData, name, type) => {
        setIs(true);
        let modal = { ...mainGrpEncounterModal }
        let SaveModal = { ...saveGrpEncounterModal }
        if (type === 'client' && !isNull(selectedData)) {
            if (name === 'GroupIdentifier') {
                let data = selectedData.PatientDataJson
                    ? JSON.parse(selectedData.PatientDataJson)
                    : []
                setSelectedPatients(data)
                // let noteTypeDD = noteTypes.filter((item => item.IsGroupTemplate))
                // noteTypeDD = noteTypeDD.filter((item => item.EHRTemplateID + "" === selectedData?.EHRTemplateID + ""))[0]
                // const noteTypeDD = noteTypes.find(item =>
                //     (AddNewEncounter?.data?.openedFor === 'New AI Encounter' ? item.IsAIEnabled : !item.IsAIEnabled) &&
                //     item.IsGroupTemplate &&
                //     String(item.EHRTemplateID) === String(selectedData?.EHRTemplateID)
                // );
                const noteTypeDD = noteTypes.find(item =>
                    item.IsGroupTemplate &&
                    String(item.EHRTemplateID) === String(selectedData?.EHRTemplateID) &&
                    (
                        AddNewEncounter?.data?.openedFor !== 'New AI Encounter' ||
                        item.IsAIEnabled
                    )
                );
                // console.log('noteTypeDD', noteTypeDD);
                if (!isNull(noteTypeDD)) {
                    modal['NoteType'] = noteTypeDD?.display ? noteTypeDD?.display : '';
                    SaveModal['EHRTemplateID'] = noteTypeDD?.EHRTemplateID ? noteTypeDD?.EHRTemplateID + "" : '';
                    SaveModal['NoteType'] = noteTypeDD?.display ? noteTypeDD?.display : '';
                } else {
                    modal['NoteType'] = '';
                    SaveModal['EHRTemplateID'] = '';
                    SaveModal['NoteType'] = '';
                }
                modal[name] = selectedData?.display;
                modal['SeenBy'] = selectedData?.ProviderID ? DropdownValueHandler(providerDD, selectedData?.ProviderID) : ''
                modal['Facility'] = selectedData?.LocationID ? DropdownValueHandler(locationDD, selectedData?.LocationID) : ''
                modal['EncounterType'] = selectedData?.DefaultEncounterType ? selectedData?.DefaultEncounterType : '';

                SaveModal[name] = selectedData?.value;
                SaveModal['SeenBy'] = selectedData?.ProviderID + "";
                SaveModal['Facility'] = selectedData?.LocationID + "";
                SaveModal['EncounterType'] = selectedData?.EncounterTypeID ? selectedData?.EncounterTypeID + "" : '';
                // SaveModal['EncounterTypeID'] = selectedData?.EncounterTypeID ? selectedData?.EncounterTypeID + "" : '';
                SaveModal['EncounterDate'] = selectedData?.AppointmentDate;
                SaveModal['IsGroupAppointment'] = 'true'
                SaveModal['IsAIGenerated'] = isAiEncounter + ""
                SaveModal['EncounterID'] = ''

            } else if (name === 'NoteType') {
                modal[name] = selectedData?.display;
                SaveModal[name] = selectedData?.value + "";
                SaveModal['EHRTemplateID'] = selectedData?.EHRTemplateID + "";
            } else if (name === 'SeenBy') {
                modal[name] = selectedData?.display;
                SaveModal[name] = selectedData?.value + "";
                modal['GroupIdentifier'] = ''
                SaveModal['GroupIdentifier'] = ''
            } else {
                modal[name] = selectedData?.display;
                SaveModal[name] = selectedData?.value + "";
            }
        } else {
            modal[name] = ''
            SaveModal[name] = ''
        }
        setMainGrpEncounterModal(modal);
        setSaveGrpEncounterModal(SaveModal);
        return selectedData
    }
    const GrpEncounterValidationM = () => {
        let ValidationModal = {
            GroupIdentifierVal: FormValidator(
                mainGrpEncounterModal.GroupIdentifier,
                enumUtil.enumValidationType.Required,
                'Appointment',
            ),
            SeenByVal: FormValidator(
                mainGrpEncounterModal.SeenBy,
                enumUtil.enumValidationType.Required,
                'Provider',
            ),
            FacilityVal: FormValidator(
                mainGrpEncounterModal.Facility,
                enumUtil.enumValidationType.Required,
                'Location',
            ),
            EncounterTypeVal: FormValidator(
                mainGrpEncounterModal.EncounterType,
                enumUtil.enumValidationType.Required,
                'Encounter Type',
            ),
            NoteTypeVal: FormValidator(
                mainGrpEncounterModal.NoteType,
                enumUtil.enumValidationType.Required,
                'Note Type',
            ),
        }
        setGrpEncounterValidation(ValidationModal)
        const isValid = Object.values(ValidationModal).every(
            value => value === ""
        );

        return isValid;
    }
    useEffect(() => {
        setIsLoading(true)
        ServerRequestProtected(API_URL_GENERAL + "/DropDown", 'post', {
            "TableName": enumUtil.enumAPITableName.GroupNote,
        }).then((response) => {
            setIsLoading(false)
            setAppointmentDD(response);
            if (AddNewEncounter?.data?.EncounterPopup?.IsGroupAppointment === 'True') {
                let data = response.filter((item => item.GroupIdentifier === AddNewEncounter?.data?.EncounterPopup?.GroupIdentifier))[0]
                if (!isNull(data)) {
                    handleSelectedData(data, 'GroupIdentifier', 'client')
                }
            }
        }).catch((error) => {
            setAppointmentDD([]);
            setIsLoading(false)
            console.error("Error loading appointment data:", error);
        });
    }, [])

    useImperativeHandle(ref, () => ({
        getSaveData() {
            return saveGrpEncounterModal;
        },
        getDisplayData() {
            return mainGrpEncounterModal;
        },
        validate() {
            return GrpEncounterValidationM();
        }
    }));
    return (
        <div className="d-flex flex-column gap-2">
            {isLoading ? <Loader /> : null}
            <div className={`input form-group ar-multiple-br m-0 pateint-serach-no-rounded ${GrpEncounterValidation.GroupIdentifierVal ? 'error' : ''}`}>
                <label className="pb-3px">Appointment</label>
                <SuperSearchSingleClient
                    type="client"
                    id='GroupIdentifier'
                    name='GroupIdentifier'
                    icon={'Simple'}
                    sup_btn='sup_btn'
                    sup_inp='superSearchVisitInp'
                    searchValue={mainGrpEncounterModal.GroupIdentifier}
                    data={appointmentDD}
                    onChange={handleChangeDD}
                    getSelectedData={handleSelectedData}
                    is={is}
                    placeholder={false}
                    SuperSearchView="DetailedView"
                    DetailedView="PatientEncounterApptGroup"
                    inputError={GrpEncounterValidation?.GroupIdentifierVal}
                />
                {GrpEncounterValidation.GroupIdentifierVal}
            </div>
            {mainGrpEncounterModal.GroupIdentifier ?
                <div className="client_detail gap-2 d-flex position-relative group-appointment new-encounter">
                    {selectedPatients.length > 0 ?
                        <div className="d-flex flex-column gap-1 w-100 h-100">

                            <div className="d-flex align-items-center gap-6">
                                <i className='icon-group-pateint fs-13'></i>
                                <p className='heading'>Participants {selectedPatients.length > 0 ? `(${selectedPatients.length})` : ''}</p>
                            </div>
                            <div className="">
                                <p className="text">
                                    {selectedPatients
                                        ?.slice(0, 5)
                                        .map(patient => patient.PatientName)
                                        .join(", ")}
                                    <span className="font-m">{selectedPatients?.length > 5 && ` +${selectedPatients.length - 5} more`}</span>
                                </p>
                            </div>


                            <div className={`d-flex align-items-center justify-content-between za_br_light ${showParticipant ? 'br-bottom-1 pb-1-5' : ''} `}>
                                <p className="heading za-blue-clr fs-11 user-select-none cursor-pointer lh-18 text-decoration-underline" onClick={() => setShowParticipant(!showParticipant)}>{showParticipant ? 'Hide All' : 'View All'}
                                </p>
                            </div>

                            {showParticipant ? <div className="d-flex flex-column gap-5">
                                {selectedPatients.map((item, index) => {
                                    return (
                                        <div className="d-flex justify-content-between align-items-center">
                                            <p className='text fs-11 ar-bullet ps-1-5'><span className='font-m fs-12'>{item.PatientName}</span> {item.DOB ? item.DOB : ''} ({item.Age}) {item.Gender}</p>
                                        </div>
                                    )
                                })}
                            </div> : <></>}

                        </div>
                        : null}
                </div>
                : <></>}
            <div className={`form-group input mb-0 ${GrpEncounterValidation.SeenByVal ? 'error' : ''}`}>
                <label className="pb-3px">Provider</label>
                <div className="input form-group ar-multiple-br m-0">
                    <SuperSearchList
                        type="client"
                        id='SeenBy'
                        name='SeenBy'
                        icon={'Simple'}
                        sup_btn='sup_btn'
                        sup_inp='superSearchVisitInp'
                        searchValue={mainGrpEncounterModal.SeenBy}
                        data={providerDD}
                        onChange={handleChangeDD}
                        getSelectedData={handleSelectedData}
                        is={is}
                        placeholder={false}
                        inputError={GrpEncounterValidation?.SeenByVal}
                    />
                    {GrpEncounterValidation.SeenByVal}
                </div>
            </div>

            <div className={`form-group input mb-0 ${GrpEncounterValidation.FacilityVal ? 'error' : ''}`}>
                <label className="pb-3px">Location</label>
                <div className="input form-group ar-multiple-br m-0">
                    <SuperSearchList
                        is={is}
                        type="client"
                        id='Facility'
                        name='Facility'
                        icon={'Simple'}
                        sup_btn='sup_btn'
                        sup_inp='superSearchVisitInp'
                        searchValue={mainGrpEncounterModal.Facility}
                        data={locationDD}
                        onChange={handleChangeDD}
                        getSelectedData={handleSelectedData}
                        placeholder={false}
                        inputError={GrpEncounterValidation?.FacilityVal}
                    />
                    {GrpEncounterValidation.FacilityVal}
                </div>
            </div>

            <div className={`input form-group ar-multiple-br m-0 ${GrpEncounterValidation.EncounterTypeVal ? 'error' : ''}`}>
                <label className="pb-3px">Encounter Type</label>
                <SuperSearchList
                    type="client"
                    id='EncounterType'
                    name='EncounterType'
                    icon={'Simple'}
                    sup_btn='sup_btn'
                    sup_inp='superSearchVisitInp'
                    searchValue={mainGrpEncounterModal.EncounterType}
                    data={visitTypes}
                    onChange={handleChangeDD}
                    getSelectedData={handleSelectedData}
                    is={is}
                    placeholder={false}
                    inputError={GrpEncounterValidation?.EncounterTypeVal}
                />
                {GrpEncounterValidation?.EncounterTypeVal}
            </div>

            <div className={`form-group input mb-0 ${GrpEncounterValidation.NoteTypeVal ? 'error' : ''}`}>
                <label className="pb-3px">Note Type</label>
                {isAiEncounter ?
                    <div className="input form-group ar-multiple-br m-0">
                        <SuperSearchList
                            type="client"
                            id='NoteType'
                            name='NoteType'
                            icon={'Simple'}
                            sup_btn='sup_btn'
                            sup_inp='superSearchVisitInp'
                            searchValue={mainGrpEncounterModal.NoteType}
                            data={handleSetDropdownData(noteTypes.filter((item => item.IsAIEnabled && item.IsGroupTemplate)), { functions: ['setEmptyDefault'] })}
                            onChange={handleChangeDD}
                            getSelectedData={handleSelectedData}
                            is={is}
                            placeholder={false}
                            inputError={GrpEncounterValidation?.NoteTypeVal}
                        />
                        {GrpEncounterValidation.NoteTypeVal}
                    </div>
                    : <div className="input form-group ar-multiple-br m-0">
                        <SuperSearchList
                            type="client"
                            id='NoteType'
                            name='NoteType'
                            icon={'Simple'}
                            sup_btn='sup_btn'
                            sup_inp='superSearchVisitInp'
                            searchValue={mainGrpEncounterModal.NoteType}
                            data={handleSetDropdownData(noteTypes.filter((item => !item.IsAIEnabled && item.IsGroupTemplate)), { functions: ['setEmptyDefault'] })}
                            onChange={handleChangeDD}
                            getSelectedData={handleSelectedData}
                            is={is}
                            placeholder={false}
                            inputError={GrpEncounterValidation?.NoteTypeVal}
                        />
                        {GrpEncounterValidation.NoteTypeVal}
                    </div>
                }
            </div>
        </div>
    )
});

export default AddNewGroupEncounter